import { Box } from '@chakra-ui/react';

import TableComponent from 'UiKit/table-component';
import useGetStudio from 'Domain/studio/useGetStudio';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { Condition } from 'Component/others';

import { useStudioState } from 'View/studio/state';
import TableSkeleton from 'View/studio/component/tableSkeleton';

import getTableList from './const';
import styles from './styles.module.css';

const Table = () => {
  const accessPermission = getMenuPermissions('master-data', 'studio');
  const { updateState, filterState, updateFilterState } = useStudioState();
  const { data, isFetching } = useGetStudio({ queryParams: filterState });
  const tableList = getTableList();
  const onSort = (sort) => updateFilterState({ sort });
  const onChangePagination = (page) => updateFilterState({ page });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableSkeleton />}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            columns={tableList}
            isCanCreate={accessPermission?.isCanCreate}
            dataSource={data?.studios}
            onSort={onSort}
            sortingData={filterState?.sort}
            emptyActionText="Create studio"
            isDataExist={data?.isDataExist}
            onEmptyStateAction={() => updateState({ isOpenFormUpsert: true })}
            maxTableHeight="calc(100vh - 301px)"
            maxTableBodyHeight="calc(100vh - 400px)"
            tableComponentHeight="calc(100vh - 233px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

export default Table;
